/**
 * AMA / AIN open-account (WhiteLabel) — Instant Access + AMA ClassicFlex (fee schedule 7).
 * Backend: `IsCustom` on account-opening fees drives `PriceStructureId` when the platform is created.
 */

export const AMA_AIN_WHITE_LABEL_IDS = ['866', '1069'] as const;

export function isAmaAinWhiteLabelId(
  whiteLabelId: string | number | null | undefined,
): boolean {
  const id = String(whiteLabelId ?? '');
  return (AMA_AIN_WHITE_LABEL_IDS as readonly string[]).includes(id);
}

export function isAmaClassicFlexOpenAccountContext(
  accountDetails: { whiteLabelId?: string | number | null },
  accountTypes: readonly {
    instantAccessOrTermAccount?: { value: number } | null;
    classicOrFlexibleFeeSchedule?: { value: number } | null;
  }[],
): boolean {
  if (!isAmaAinWhiteLabelId(accountDetails?.whiteLabelId)) {
    return false;
  }
  const at = accountTypes?.[0];
  if (!at) {
    return false;
  }
  const instant = at.instantAccessOrTermAccount?.value;
  const classic = at.classicOrFlexibleFeeSchedule?.value;
  return instant === 1 && classic === 7;
}

export function platformProcessingFeesAreEqual(
  a: number,
  b: number,
  epsilon = 0.000001,
): boolean {
  return Math.abs(a - b) < epsilon;
}
